export default function FaqConvertMarkdownToHtml(markdown) {
  if (markdown === null) return '';

  // Convert bold text
  markdown = markdown?.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

  // Split the content into paragraphs and lists
  const parts = markdown?.split(/\n{2,}/);

  const processedParts = parts?.map(part => {
    if (part.trim().startsWith('-')) {
      // This is a list
      const listItems = part.split('\n').map(item => {
        return item.trim().startsWith('-') ? 
          `<li class="mb-2">${item.substring(1).trim()}</li>` : 
          item;
      }).join('');
      return `<ul class="list-disc list-outside pl-5 space-y-2">${listItems}</ul>`;
    } else {
      // This is a paragraph
      return `<p class="mb-4">${part.trim()}</p>`;
    }
  });

  markdown = processedParts?.join('');

  // Convert links
  markdown = markdown?.replace(
    /\[(.*?)\]\((.*?)\)/g,
    '<a href="$2" style="color: #00A1E0;">$1</a>'
  );

  return markdown;
}